import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function HeroSection() {
  const { section, id } = useParams();
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    (async () => await fetchSlidesData())();
  }, [section, id]);

  async function fetchSlidesData() {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}pagdata?itemName[eq]=slid_show&status02[eq]=publish`,
        ),
      ]);

      const [menueData] = responses;
      if (menueData.data.status === 200) {
        if (menueData.data.allData.length === 0) {
          setSlides([]);
          console.log("Oops!", "Sorry! we did not find any Menue");
        } else {
          setSlides(menueData.data.allData);
        }
      } else {
        console.log("Oops!", menueData.data.validation_error);
      }
    } catch (error) {
      console.log("Error", "There were no Data found!");
    }
  }

  if (slides.length === 0) {
    return null; // Nothing renders if there's no data
  }

  return (
    <section id="hero" className="hero section dark-background">
      <div
        id="hero-carousel"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      >
        {/* Slides */}
        <div className="carousel-inner">
          {slides.map((slide, index) => (
            <div
              className={`carousel-item position-relative ${
                index === 0 ? "active" : ""
              }`}
              key={index}
            >
              {slide.item01 &&
                slide.item01 !== "undefined" &&
                slide.item01 !== "null" &&
                slide.item01.trim() !== "" && (
                  <>
                    <img
                      loading={index === 0 ? "eager" : "lazy"}
                      fetchPriority={index === 0 ? "high" : "auto"}
                      decoding="async"
                      src={`${BACKEND_URL}upload/${slide.item01}`}
                      className="d-block w-100"
                      alt={`Slide ${index + 1 || 1}`}
                    />
                  </>
                )}
              <div className="carousel-container">
                <h3
                  style={{
                    lineHeight: "1.3",
                    fontSize: "2.1rem",
                    textTransform: "uppercase",
                    fontWeight: "800",
                  }}
                >
                  {slide.item03}
                </h3>
                <h4>{slide.item03b}</h4>
                {/* <Link to="#featured-services" className="btn-get-started">
                  Get Started
                </Link> */}
              </div>
            </div>
          ))}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#hero-carousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon fa-solid fa-chevron-left"
            aria-hidden="true"
          />
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#hero-carousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon fa-solid fa-chevron-right"
            aria-hidden="true"
          />
          <span className="visually-hidden">Next</span>
        </button>

        {/* Indicators */}
        <ol className="carousel-indicators">
          {slides.map((_, index) => (
            <li
              key={index}
              data-bs-target="#hero-carousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
            ></li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default HeroSection;
